module.exports = __webpack_public_path__ + "img/W7027-mod.d085e42c.jpg";